import { useLocalStorage } from '@ai-tutor/ui';
import { WellbeingRoom } from '../WellbeingRoom';
import { useWellbeingKeys } from '../wellbeingStorage';
import { WorryDump, type Worry } from './WorryDump';

/** The Worry dump page: a writing surface, kept on this device. */
export function WorryRoom() {
  const keys = useWellbeingKeys();
  const [worries, setWorries] = useLocalStorage<Worry[]>(keys.worries, []);

  return (
    <WellbeingRoom
      title='Worry dump'
      description="Write it down so your head doesn't have to hold it."
    >
      <div className='mx-auto max-w-xl'>
        <WorryDump
          worries={worries}
          // The page exists to be written in: start with the cursor there.
          focusOnMount
          onAdd={text =>
            setWorries([
              ...worries,
              { id: `worry-${Date.now()}`, text, createdAt: Date.now() },
            ])
          }
          onLetGo={id => setWorries(worries.filter(w => w.id !== id))}
        />
      </div>
    </WellbeingRoom>
  );
}
